import Permissions from "../../models/Permissions";

const Rescisao = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "Cálculo de Rescisão",
  icon: "fa fa-calculator",
  group: "Folha",
  permissions,
};

export default [
  {
    path: "/rescisao",
    name: "Cálculo Rescisão",
    component: Rescisao,
    meta,
  },
];
